import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import { LocationsService } from '../locations.service';

export const LocationsResolver: ResolveFn<Location[]> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Location[]> => {
    const locationsService: LocationsService = inject(LocationsService);
    return locationsService.list(route.params['id']);
}
